export const tooltipStyle = (isDark: boolean) => {
	return {
		background: isDark ? '#1d2023' : '#fff',
	};
};
